import React from 'react'
import Devices from '../components/Devices'

export default function DownloadPage() {
  return (
    <div>
      <Devices />
    </div>
  )
}
